import { Box } from "@mui/material";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ClaimsContainer from "./claims";
import CouponsContainer from "./coupons";
import PromotionsMenu from "./PromotionsMenu";
import ReferralsContainer from "./referrals";
import RewardsContainer from "./rewards";
import RewardProgramDetails from "./rewards/RewardProgramDetails";
import TopUpBonusesContainer from "./topupBonuses";

const PromotionsContainer = () => {
  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%" }}>
      <PromotionsMenu />
      <Box sx={{ flex: 1, padding: 3, overflow: "auto" }}>
        <Routes>
          <Route path="/" element={<Navigate to="coupons" replace={true} />} />
          <Route path="/coupons" element={<CouponsContainer />} />
          <Route path="/referrals" element={<ReferralsContainer />} />
          <Route
            path="/rewards/:programId"
            element={<RewardProgramDetails />}
          />
          <Route path="/rewards" element={<RewardsContainer />} />
          <Route path="/claims" element={<ClaimsContainer />} />
          <Route path="/topup-bonuses" element={<TopUpBonusesContainer />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default PromotionsContainer;
